// @ts-nocheck
import { Router } from '@gatsbyjs/reach-router';
import React from 'react';

import DocumentPage from '../components/DocumentPage/DocumentPage';
import AppLayout from '../components/layout/AppLayout';

const Document = () => {
  return (
    <AppLayout>
      <Router>
        <DocumentPage path="/documents" />
      </Router>
    </AppLayout>
  );
};
export default Document;
